module.exports = __webpack_public_path__ + "static/media/microsoft_azure1.7f6723d8.png";